import React, { useEffect, useState } from "react";

import "./App.css";
import { ToastContainer } from "react-toastify";
import Bartenders from "./pages/Bartenders";
import DiscountManager from "./pages/DiscountManager";
import { Route, Routes } from "react-router-dom";
import { Login } from "./pages/auth/Login";
import { SignUp } from "./pages/auth/SignUp";
import ForgetPassword from "./pages/auth/ForgetPassword";
import CheckEmail from "./pages/auth/CheckEmail";
import ResetPassword from "./pages/auth/ResetPasswordSecond";
import BartenderSchedulePage from "./pages/Schedule/BartenderSchedulePage";
import PrivateRoutes from "./constants/utils/PrivateRoutes";
import PublicRoute from "./constants/utils/PublicRoute";
import ChangePassword from "./pages/ChangePassword";
import Company from "./pages/company/Company";
import CompaniesList from "./pages/company/Companies";
import PriceCalculation2 from "./pages/company/PriceCalculation2/PriceCalculation";
import EditCompanyPage from "./pages/SuperAdmin/EditCompanyPage";
import EventsPage from "./pages/events/EventsPage";
import DashboardLayout from "./layouts/DashboardLayout";
import { Dashboard } from "./pages/dashboard/Dashboard";
import { PaymentsPage } from "./pages/payments/PaymentsPage";
import PackagesPage from "./pages/btc/Packages/PackagesPage";
import EditPackageBTC from "./pages/btc/Packages/EditPackageBTC";
import NewPackageBTC from "./pages/btc/Packages/NewPackageBTC";
import CocktailsPage from "./pages/btc/Cocktails/CocktailsPage";
import EditCocktailBTC from "./pages/btc/Cocktails/EditCocktailBTC";
import NewCocktailBTC from "./pages/btc/Cocktails/NewCocktailBTC";
import MyBusiness from "./pages/MyBusiness/MyBusiness";
import BillingPage from "./pages/billing/BillingPage";
import CardCheckRoutes from "./constants/utils/CardCheck";

function App() {

  return (
    <div className="h-full bg-white">
      <ToastContainer />
      <Routes>
        {/* public routes */}

        <Route element={<PublicRoute />}>
          <Route path="/signup" element={<SignUp />} />
          <Route path="/login" element={<Login />} />
          <Route path="/forget/password" element={<ForgetPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/checkemail" element={<CheckEmail />} />
        </Route>
      </Routes>
      <DashboardLayout>
        <Routes>
          {/* private */}
          <Route element={<PrivateRoutes />}>
            <Route element={<CardCheckRoutes />}>
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/company" element={<CompaniesList />} />
              <Route path="/payments" element={<PaymentsPage />} />
              <Route path="/events" element={<EventsPage />} />
              <Route path="/business" element={<MyBusiness />} />
              <Route path="/packages" element={<PackagesPage />} />
              <Route path="/packages/new" element={<NewPackageBTC />} />
              <Route path="/packages/:id" element={<EditPackageBTC />} />
              <Route path="/cocktails" element={<CocktailsPage />} />
              <Route path="/cocktails/new" element={<NewCocktailBTC />} />
              <Route path="/cocktails/:id" element={<EditCocktailBTC />} />
              <Route path="/create-company" element={<Company />} />
              <Route path="/edit-company/:id" element={<EditCompanyPage />} />
              <Route path="/pricecalculator" element={<PriceCalculation2 />} />
              <Route path="/billing" element={<BillingPage />} />

              {/* <Route path="/edit-package/:id" element={<EditPackage  />} /> */}
              {/* <Route path="/edit-cocktail/:id" element={<EditCocktail  />} /> */}

              <Route
                path="/bartenders/schedule"
                element={<BartenderSchedulePage />}
              />
              <Route path="/" element={<Bartenders />} />
              {/* <Route path="/addbartender" element={<AddBartender />} /> */}
              <Route path="/discount" element={<DiscountManager />} />
              <Route path="/change-password" element={<ChangePassword />} />
            </Route>
          </Route>
        </Routes>
      </DashboardLayout>
    </div>
  );
}

export default App;

